import classNames from "classnames";
import Separator from "shared/components/common/separater";
import ModifyQuestions from "shared/components/modifyQuestionnaire/modifyQuestions";
import styles from "./style.module.scss";
import ModifyOption from "shared/components/modifyQuestionnaire/modifyOptions";
import { GetQuestionnaireService } from "shared/services/questionnaire";
import { useEffect, useState } from "react";

const ModifyQuestionnaire = () => {
  const [response, setResponse] = useState<any>(null);
  const handleQuestionnaire = () => {
    GetQuestionnaireService()
      .then(({ data }) => {
        setResponse(data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handleQuestionnaire();
  }, []);
  return (
    <div className={classNames(styles.mainContainer, "gap-6")}>
      <p>Questions/Definitions </p>
      <h1>Please choose the question or definitions you want to edit.</h1>
      <Separator />
      <ModifyQuestions data={response} />
      <Separator />
      <ModifyOption data={response} />
    </div>
  );
};

export default ModifyQuestionnaire;
